import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { AccordionIconGraphics } from './AccordionIconGraphics';
import { MOBILE_SAFE_RESIZE } from '../globalUtils';
const AccordionPanel = ({ title, startOpen, children, }) => {
    const [_, setRender] = useState(0);
    const containerRef = useRef(null);
    const headerRef = useRef(null);
    const contentRef = useRef(null);
    const open = useRef(!!startOpen);
    const mounted = useRef(false);
    const onOpenToggle = () => {
        open.current = !open.current;
        setHeight(true);
        setRender((x) => x + 1);
    };
    const setHeightOnFrame = () => {
        setHeight();
    };
    const setHeight = (animated) => {
        if (containerRef.current) {
            if (animated) {
                containerRef.current.style.transition =
                    'height 0.66s cubic-bezier(.24,0,0,1)';
            }
            else {
                containerRef.current.style.transition = '';
            }
            if (headerRef.current && contentRef.current && containerRef.current) {
                const headerBounds = headerRef.current.getBoundingClientRect();
                if (open.current) {
                    const contentBounds = contentRef.current.getBoundingClientRect();
                    containerRef.current.style.height = `${headerBounds.height + contentBounds.height}px`;
                }
                else {
                    containerRef.current.style.height = `${headerBounds.height}px`;
                }
            }
        }
    };
    const onResize = () => {
        requestAnimationFrame(setHeightOnFrame);
    };
    useEffect(() => {
        window.addEventListener(MOBILE_SAFE_RESIZE, onResize);
        setHeight();
        return () => {
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResize);
        };
    }, []);
    if (!mounted.current) {
        mounted.current = true;
    }
    return (_jsxs("div", { className: "accordion-panel", ref: containerRef, children: [_jsxs("div", { className: "accordion-panel-header", onClick: onOpenToggle, ref: headerRef, children: [_jsx("div", { className: "accordion-panel-title", children: title }), _jsx(AccordionIconGraphics, { className: open.current ? 'open' : undefined })] }), _jsx("div", { className: "accordion-panel-content", ref: contentRef, children: children })] }));
};
export default AccordionPanel;
